import SelectDisplayMetric from "./SelectDisplayMetric";

export default SelectDisplayMetric;